<template>
  <div
    :class="['skeleton-circles', { 'skeleton-circles--mobile': isMobile }]"
    aria-label="Loading content"
    aria-busy="true"
  >
    <div
      v-for="index in skeletonCount"
      :key="index"
      class="skeleton-circle-item"
      :style="{ marginRight: margin + 'px' }"
    >
      <span class="skeleton-circle"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircularSkeletonLoading',
  props: {
    skeletonCount: {
      type: Number,
      default: 9,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    margin: {
      type: Number,
      default: 10,
    },
  },
}
</script>

<style scoped lang="scss">
.skeleton-circles {
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  padding-bottom: 10px;
}

.skeleton-circles--mobile {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;

  -ms-overflow-style: none;
}

.skeleton-circle-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  margin-bottom: -2px;
}

.skeleton-circle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: $skeleton_color;
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
</style>
